import React, { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import LayoutSidebarMenu from './LayoutSidebarMenu';
import { UilArrowFromRight, UilLeftArrowToLeft } from '@iconscout/react-unicons';
import Button from 'components/base/Button';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface LayoutSidebarProps {
  show?: boolean;
  onHide?: () => void;
}

const LayoutSidebar = ({ show = false, onHide }: LayoutSidebarProps) => {
  const { t } = useTranslation();
  const {
    config: { isNavbarVerticalCollapsed, isDark },
    setConfig,
  } = useAppContext();

  const { breakpoints } = useBreakpoints();
  const isMobile = breakpoints.down('lg');

  const menuItems = [
    { name: 'home', icon: 'home', path: '/', active: true },
    { name: 'contacts', icon: 'users', path: '/contacts', active: true },
    { name: 'class', icon: 'book-open', path: '/class', active: true },
    { name: 'courses', icon: 'monitor', path: '/courses', active: true },
    { name: 'pricing', icon: 'dollar-sign', path: '/pricing', active: true },
  ];

  const handleToggleCollapse = () => {
    setConfig({ isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed });
  };

  // Manage body class for mobile sidebar
  useEffect(() => {
    if (isMobile && show) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [isMobile, show]);

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && (
        <div
          className={classNames('layout-sidebar-overlay', { show })}
          onClick={onHide}
        />
      )}

      <div
        className={classNames('layout-sidebar', {
          collapsed: isNavbarVerticalCollapsed && !isMobile,
          show: show, // Sử dụng show prop trực tiếp
        })}
        data-bs-theme={isDark ? 'dark' : 'light'}
        style={{
          // Đảm bảo sidebar ẩn hoàn toàn trên mobile khi không show
          display: isMobile && !show ? 'none' : 'block'
        }}
      >
        <Navbar className="navbar-vertical" expand="lg" variant="">
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul">
              <LayoutSidebarMenu routes={menuItems} onLinkClick={isMobile ? onHide : undefined} />
            </Nav>
          </div>

          <div className="navbar-vertical-footer">
            <Button
              className="navbar-vertical-toggle d-flex align-items-center gap-2"
              variant=""
              onClick={handleToggleCollapse}
            >
              {isNavbarVerticalCollapsed ? (
                <UilArrowFromRight size={16}  />
              ) : (
                <>
                  <UilLeftArrowToLeft size={16} />
                  <span>{t('collapsed_view')}</span>
                </>
              )}
            </Button>
          </div>
        </Navbar>
      </div>
    </>
  );
};

export default LayoutSidebar;
